import { useId, type ReactNode } from 'react';
import type { HotelOfferView } from '../models.js';
import { HotelOfferContent } from './hotel_offer_card.js';

type HotelOfferRowProps = {
  offer: HotelOfferView;
  detailsLabel: string;
  selected?: boolean;
  busy?: boolean;
  onDetailsOpen(hotelId: string): void;
};

export function HotelOfferRow({
  offer,
  detailsLabel,
  selected = false,
  busy = false,
  onDetailsOpen,
}: Readonly<HotelOfferRowProps>): ReactNode {
  const unavailable = !offer.detailsAvailable;
  // O `aria-label` é o nome do botão e cala o texto de dentro: o acordo
  // (#6928) chega ao leitor de tela como descrição.
  const agreementId = useId();
  return (
    <button
      type="button"
      className="hui-hotel-offer-row"
      aria-label={`${detailsLabel} — ${offer.name}`}
      aria-current={selected || undefined}
      aria-describedby={offer.agreedRateLabel ? agreementId : undefined}
      data-hotel-details-trigger={offer.detailsAvailable ? offer.id : undefined}
      disabled={busy || unavailable}
      onClick={() => {
        if (!busy && !unavailable) onDetailsOpen(offer.id);
      }}
    >
      <HotelOfferContent offer={offer} showBadges={false} agreementId={agreementId} />
    </button>
  );
}
